import NavigationServicesHeader from "../Header/NavigationServicesHeader";
import * as OFMSUI from "react-bootstrap";
import { Formik, Field, ErrorMessage, useFormik, FormikProvider } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import HousingService from "../Services/HousingService";
import { BiLock, BiUser, BiShow, BiHide } from "react-icons/bi";
import Swal from "sweetalert2";

const ChangePassword = () => {
  const history = useHistory();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    oldpassword: Yup.string().required("Required"),
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("Required"),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Required"),
  });

  const showNotification = (type, message) => {
    Swal.fire(type === "success" ? "Success" : "Error", message, type);
  };

  const formik = useFormik({
    initialValues: {
      oldpassword: "",
      newPassword: "",
      confirmpassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      const params = {
        oldpassword: values.oldpassword,
        newpassword: values.newPassword,
        confirm_newpassword: values.confirmpassword,
      };
      Swal.fire({
        text: "Do you want to change the password?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          HousingService.changePassword(params).then((response) => {
            const { SCODE, SDESC } = response?.data || {};
            if (SCODE === "01") {
              showNotification("success", SDESC);
              resetForm();
            } else {
              showNotification("error", SDESC);
            }
          });
        }
      });
    },
  });

  // Toggle password visibility
  const togglePasswordVisibility = (type) => {
    if (type === "old") {
      setShowOldPassword(!showOldPassword);
    } else if (type === "new") {
      setShowNewPassword(!showNewPassword);
    } else if (type === "confirm") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  return (
    <div>
      <NavigationServicesHeader />
      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} lg={6} className="page-titlespacing">
            <div className="inner-herbpage-service-title1">
              <h1 style={{ marginLeft: "-15px" }}>Change Password</h1>
            </div>
          </OFMSUI.Col>
          <OFMSUI.Col xs={12} lg={6} className="page-titlespacing text-end">
            <button
              className="btn btn-primary"
              style={{ marginTop: "17px" }}
              onClick={() => history.goBack()}
            >
              Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <FormikProvider value={formik}>
        <OFMSUI.Container className="outer-page-content-container">
          <OFMSUI.Row className="p-4 justify-content-center">
            <OFMSUI.Col xs={12} lg={4}>
              <form onSubmit={formik.handleSubmit}>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <BiUser className="font_size text-white" />
                  </span>
                  <input
                    placeholder="username"
                    name="username"
                    type="text"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    className="enter-password form-control"
                    autoComplete="off"
                    value={localStorage.getItem("username")}
                    disabled
                  />
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <BiLock className="font_size text-white" />
                  </span>
                  <input
                    placeholder="oldpassword"
                    name="oldpassword"
                    type={showOldPassword ? "text" : "password"}
                    className={
                      formik.touched.oldpassword && formik.errors.oldpassword
                        ? "enter-password form-control is-invalid"
                        : "enter-password form-control"
                    }
                    autoComplete="off"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.oldpassword}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => togglePasswordVisibility("old")}
                  >
                    {showOldPassword ? <BiHide /> : <BiShow />}
                  </button>
                  <ErrorMessage name="oldpassword" component="div" className="invalid-feedback" />
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <BiLock className="font_size text-white" />
                  </span>
                  <input
                    placeholder="newPassword"
                    name="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    className={
                      formik.touched.newPassword && formik.errors.newPassword
                        ? "enter-password form-control is-invalid"
                        : "enter-password form-control"
                    }
                    autoComplete="off"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPassword}
                    maxLength={15}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => togglePasswordVisibility("new")}
                  >
                    {showNewPassword ? <BiHide /> : <BiShow />}
                  </button>
                  <ErrorMessage name="newPassword" component="div" className="invalid-feedback" />
                </div>

                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <BiLock className="font_size text-white" />
                  </span>
                  <input
                    placeholder="Confirm Password"
                    name="confirmpassword"
                    type={showConfirmPassword ? "text" : "password"}
                    className={
                      formik.touched.confirmpassword && formik.errors.confirmpassword
                        ? "enter-password form-control is-invalid"
                        : "enter-password form-control"
                    }
                    autoComplete="off"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmpassword}
                    maxLength={15}
                  />
                  <button type="button" className="btn btn-outline-secondary" onClick={() => togglePasswordVisibility("confirm")} > {showConfirmPassword ? <BiHide /> : <BiShow />} </button>
                  <ErrorMessage
                    name="confirmpassword"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>

                <div className="d-grid mt-3">
                  <button type="submit" className="btn btn-success btn-sm">
                    Change Password
                  </button>
                </div>
              </form>
            </OFMSUI.Col>
          </OFMSUI.Row>
        </OFMSUI.Container>
      </FormikProvider>
    </div>
  );
};

export default ChangePassword;
